import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import ActionButton from '../../ui/ActionButton';
import ContainerStyles from '../../ui/Container';
import HeaderWrapperStyles from '../../ui/HeaderWrapper';
import TitleStyles from '../../ui/Title';
import VideoWrapperStyles from '../../ui/VideoWrapper';
import VideoComponent from '../VideoComponent';

import Video from '../../../interfaces/video';
import { AppState } from '../../../store';

const OnboardingComponent: React.FC = () => {
  const [videos, setVideos] = useState<Array<Video>>([]);
  const videosState = useSelector<AppState, Video[]>((state) => state.onboarding.videos);

  /**
   * Garante o posicionamento dos vídeos
   * nos guias independente da ordem do JSON
   * Limita também o tamanho do array.
   */
  const feedVideos = (): void => {
    const videoIds = [
      'dispensacao_parcial',
      'dispensacao_digital',
      'cancelamento_da_dispensacao',
      'validacao_da_assinatura_portal_iti'
    ];
    const videosGuides = videosState.filter(video => {
      if (videoIds.includes(video.id)) {
        return video;
      }
      return null;
    }).sort((a, b) => videoIds.indexOf(a.id) - videoIds.indexOf(b.id));

    videosState.forEach((video) => {
      if (video.id === 'dispensacao_parcial') videosGuides.splice(0, 1, video);
      if (video.id === 'dispensacao_digital') videosGuides.splice(1, 1, video);
      if (video.id === 'cancelamento_da_dispensacao') videosGuides.splice(2, 1, video);
      if (video.id === 'validacao_da_assinatura_portal_iti') videosGuides.splice(3, 1, video);
    });
    setVideos(videosGuides);
  };

  useEffect(feedVideos, [videosState]);

  return (
    <ContainerStyles>
      <HeaderWrapperStyles>
        <TitleStyles>Guias rápidos iniciais</TitleStyles>
        <TitleStyles fontWeight="normal" fontSize={14} lineHeight="20px" gridAread="Subtitle">
          O que você precisa saber para iniciar sua jornada na Memed.
        </TitleStyles>
        <ActionButton
          id="button-see-all-videos"
          className="onboarding-action-see-all-videos"
          onClick={(): void => {
            const helpButton = document.getElementById('dropdown-container-help');
            if (helpButton) helpButton.click();
          }}
        >
          Ver todos os vídeos
        </ActionButton>
      </HeaderWrapperStyles>
      <VideoWrapperStyles>
        {videos.map((video: Video): JSX.Element | string => {
          return <VideoComponent video={video} key={video.id} />;
        })}
      </VideoWrapperStyles>
    </ContainerStyles>
  );
};

export default OnboardingComponent;
